import Vue from 'vue'
import Vuex from 'vuex'
// import VuexPersistence from 'vuex-persist'
import getters from './getters'


Vue.use(Vuex);
// vuex持久化
// const vuexLocal = new VuexPersistence({
// 	key: 'VUEX-PERSIST',
// 	storage: window.localStorage,
// 	reducer: function (state) {
// 		return {
// 			// 需要持久化的数据放入这里
// 			user: state.user,
// 			message: state.message,
// 			notice: state.notice
// 		}
// 	}
// })
const modulesFiles = require.context('./modules', false, /\.js$/)
// 不再需要 import user from './modules/user' 这样一个个的来引入了
// 可以自动引入 modules下的文件
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    // set './app.js' => 'app'
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
    const value = modulesFiles(modulePath)
    modules[moduleName] = value.default
    return modules
}, {})

export default new Vuex.Store({
    getters,
    state: {},
    mutations: {},
    actions: {},
    modules,
    // plugins: [vuexLocal.plugin]
})
function cloneState (data) {
	return JSON.parse(JSON.stringify(data))
}




// WEBPACK FOOTER //
// ./src/store/index.js